import Svg, { Ellipse, Path } from 'react-native-svg';
import { TIllustrationProps } from './types';

export const IlustrationNoFamilyMembers = ({
  width = 135,
  height = 110,
  className,
}: TIllustrationProps) => (
  <Svg
    width={width}
    height={height}
    fill="none"
    className={className}
    viewBox="0 0 135 110"
  >
    <Path
      fill="#fff"
      d="M134.425 60.314c0-16.673-13.532-30.188-30.227-30.188H98.32C93.513 15.536 79.76 5 63.538 5c-20.22 0-36.61 16.368-36.61 36.562 0 1.172.058 2.328.166 3.469a23.032 23.032 0 0 0-3.68-.298C10.76 44.736.5 54.977.5 67.617.5 80.255 10.76 90.5 23.415 90.5h81.534v-.009c16.347-.397 29.479-13.758 29.479-30.178h-.003Z"
    />
    <Path
      fill="#FDBD9A"
      fillRule="evenodd"
      d="M76.365 90.358c-.31-6.011-2.47-11.954-6.536-16.788-9.496-11.29-25.789-12.242-36.388-2.13-5.298 5.054-8.171 11.911-8.537 18.918h51.462Z"
      clipRule="evenodd"
    />
    <Ellipse cx={50.778} cy={48.637} fill="#FDBD9A" rx={13.081} ry={13.875} />
    <Path
      fill="#FF8D78"
      fillRule="evenodd"
      d="M95.34 90.358c-.31-6.011-2.47-11.954-6.537-16.788-9.495-11.29-25.788-12.242-36.387-2.13-5.298 5.054-8.172 11.911-8.537 18.918H95.34Z"
      clipRule="evenodd"
    />
    <Ellipse cx={69.754} cy={48.637} fill="#FF8D78" rx={13.081} ry={13.875} />
    <Path
      fill="#FE7165"
      fillRule="evenodd"
      d="M115.32 90.358c-.311-6.011-2.47-11.954-6.537-16.788-9.496-11.29-25.789-12.242-36.388-2.13-5.298 5.054-8.171 11.911-8.537 18.918h51.462Z"
      clipRule="evenodd"
    />
    <Ellipse cx={89.733} cy={48.637} fill="#FE7165" rx={13.081} ry={13.875} />
    <Path
      fill="#C4E8E4"
      d="M132.046 88.397c0-9.17-7.458-16.602-16.659-16.602h-3.239c-2.649-8.025-10.229-13.819-19.169-13.819-11.143 0-20.176 9.002-20.176 20.108 0 .645.032 1.28.092 1.908a12.71 12.71 0 0 0-2.028-.164c-6.975.002-12.629 5.635-12.629 12.586 0 6.95 5.654 12.586 12.629 12.586H115.8v-.005c9.009-.218 16.247-7.567 16.247-16.598h-.002Z"
    />
  </Svg>
);
